import React from 'react';
import PropTypes from 'prop-types';
import { useOutletContext } from 'react-router-dom';

const CheckoutCode = ({ code }) => {
  const closeIconUrl = '/static/img/red-delete.svg';
  const { dispatch } = useOutletContext();

  const handleClick = () => dispatch({ type: 'REMOVE_ACTIVE_CODE' });

  return (
    <div className="price-summary-box__checkout-code-row">
      <span className="price-summary-box__checkout-code">
        <span className="price-summary-box__checkout-code-text" title={code.name}>
          {code.name}
        </span>
        <input
          className="price-summary-box__checkout-code-remove-button"
          type="image"
          src={closeIconUrl}
          alt="Remove checkout code"
          onClick={handleClick}
        />
      </span>
    </div>
  );
};

CheckoutCode.propTypes = {
  code: PropTypes.shape({
    name: PropTypes.string.isRequired,
    code_type: PropTypes.string.isRequired,
    discount_amount: PropTypes.number,
    remaining_credits: PropTypes.number,
    error: PropTypes.string,
  }).isRequired,
};

export default CheckoutCode;
